import { createModel } from '@rematch/core';
import { AccreditationCenters, IAccreditationCenterDetails } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';
import { IAccreditationCentersFilters, IQualificationsFilters } from 'components/reduxModels';
import { IQualificationInfoList } from 'components/models';

const initialState: State = {
    accreditationCenters: null,
    accreditationCenterQualifications: null,
    accreditationCenterDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setAccreditationCenters: (state, accreditationCenters: State['accreditationCenters']): State => ({ ...state, accreditationCenters }),
        setAccreditationCenterDetails: (state, accreditationCenterDetails: State['accreditationCenterDetails']): State => ({ ...state, accreditationCenterDetails }),
        setQualifications: (state, accreditationCenterQualifications: State['accreditationCenterQualifications']): State => ({ ...state, accreditationCenterQualifications }),
    },
    effects: (dispatch: any) => ({
        async getAccreditationCenters(payload: IAccreditationCentersFilters) {
            const result = await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAccreditationCenters(
                payload.qualificationIds,
                undefined,
                payload.searchField,
                payload.searchTerm,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
              ),
            );
            if (!result) return;
            this.setAccreditationCenters(result);
        },
        async getAccreditationCenter(accreditationCenterId: string) {
            this.setAccreditationCenterDetails(await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAccreditationCenter(accreditationCenterId),
            ));
        },
        async getAccreditationCenterQualifications(payload: IQualificationsFilters) {
            const result = await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getQualifications(
                payload.occupationalStandardId,
                payload.readyToUse,
                payload.residency,
                payload.searchField,
                payload.searchTerm,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
              ),
            );
            if (!result) return;
            this.setQualifications(result);
        },
    }),
});

interface State {
    accreditationCenters: AccreditationCenters | null;
    accreditationCenterQualifications: IQualificationInfoList | null;
    accreditationCenterDetails: IAccreditationCenterDetails | null;
}
